export default __webpack_public_path__ + "static/media/Xero_Integration.392f4a70.mp4";